import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SculptureDetail from "../pages/sculpture-detail/page";
import Underskin from "../pages/underskin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sculpture/:id",
    element: <SculptureDetail />,
  },
  {
    path: "/underskin",
    element: <Underskin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
